import styled, {css, SimpleInterpolation} from "styled-components";

export const ExportButtonCtn = styled.span`
  height: 44px;
  position: relative;
  border: solid 1px #56565b;
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Arial;
  font-size: 15px;
  font-weight: bold;
  margin-top: 15px;
  text-align: center;
  background: white;
  
  &:hover {
    background-color: #dbdbdb;
    cursor: pointer;
  }
  
  ${(props): SimpleInterpolation => props.open && css`
    background-color: #dbdbdb;
  `}
`;

export const ExportOptionsCtn = styled.div`
  position: absolute;
  top: 100%;
  display:flex;
  flex-direction: column;
  max-height: 0px;
  transition: all 0.2s ease-in-out;
  overflow: hidden;
  width: 100%;
  
  ${(props): SimpleInterpolation => props.open && css`
    max-height: 80px;
  `}
  
`;

export const ExportOption = styled.div`
  font-size: 14pt;
  height: 40px;
  display: flex
`;

export const ExportOptionButton = styled.button`
  font-size: 14pt;
  height: 100%;
  width: 100%;
  
  :hover {
    background-color: #D9D9D9;
    cursor: pointer;
  }
`;